import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DocumentAnalysisRow } from '@features/dashboard/document-analysis/document-analysis.model';

@Component({
  selector: 'app-document-analysis-cards',
  templateUrl: './document-analysis-cards.component.html',
  styleUrls: ['./document-analysis-cards.component.scss'],
  standalone: false,
})
export class DocumentAnalysisCardsComponent {
  @Input() rows: DocumentAnalysisRow[] = [];

  @Output() analyze = new EventEmitter<string>();
}
